type Iteratee<T> = ((item: T) => PropertyKey) | keyof T;

/**
 * Native replacement for lodash/fp `groupBy`. Groups the items of `collection`
 * into an object keyed by the result of `iteratee` (a function or a property
 * key), preserving insertion order within each group.
 */
export default function groupBy<T>(
    collection: readonly T[] | null | undefined,
    iteratee: Iteratee<T>,
): Record<string, T[]> {
    return (collection ?? []).reduce<Record<string, T[]>>((groups, item) => {
        const key = String(typeof iteratee === 'function' ? iteratee(item) : item[iteratee]);
        (groups[key] ??= []).push(item);
        return groups;
    }, {});
}
